import React, { memo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import makeStyles from '@material-ui/styles/makeStyles';
import { Theme } from '@material-ui/core';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Button from '@material-ui/core/Button';
import { AuthParamKeys } from '~/models/Auth/AuthParamModel';
import AuthContent from '../AuthContent';
import { AuthDialogContext } from './AuthDialogContextProvider';

const useStyles = makeStyles((theme: Theme) => ({
  dialogPaper: {
    margin: theme.spacing(1),
  },
  tabs: {
    marginBottom: theme.spacing(3),
  },
  tabsFlexContainer: {
    justifyContent: 'center',
  },
  dialogContent: {
    padding: theme.spacing(1, 2, 0),

    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2, 4, 0),
    },
  },
  dialogActions: {
    padding: theme.spacing(2),
  },
}));

interface Props {
  authParams?: { [key in AuthParamKeys]?: string };
}

const AuthDialog = memo(({ authParams }: Props) => {
  const { open, isSignup, setIsSignup, handleClose } =
    useContext(AuthDialogContext);
  const { t } = useTranslation();
  const classes = useStyles();
  const tabValue = isSignup ? 0 : 1;

  const handleChangeTab = (event, newValue) => setIsSignup(newValue === 0);

  return (
    <Dialog
      open={open}
      fullWidth
      classes={{ paper: classes.dialogPaper }}
      onClose={handleClose}
    >
      <div className={classes.dialogContent}>
        <Tabs
          value={tabValue}
          onChange={handleChangeTab}
          classes={{
            root: classes.tabs,
            flexContainer: classes.tabsFlexContainer,
          }}
        >
          <Tab label={t('logins.signupDialogTitle')} />
          <Tab label={t('logins.loginDialogTitle')} />
        </Tabs>
        <AuthContent signup={isSignup} authParams={authParams} />
      </div>
      <DialogActions classes={{ root: classes.dialogActions }}>
        <Button onClick={handleClose}>{t('common.close')}</Button>
      </DialogActions>
    </Dialog>
  );
});

export default AuthDialog;
